import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import api from "@/lib/api";

export const ChatIcon = () => {
  const navigate = useNavigate();
  const [unread, setUnread] = useState(0);
  const alive = useRef(true);
  useEffect(() => {
    alive.current = true;
    const load = () => Promise.all([
      api.get("/messenger/unread-total").then(({ data }) => data.count || 0).catch(() => 0),
      api.get("/messages/unread-count").then(({ data }) => data.count || 0).catch(() => 0),
    ]).then(([a, b]) => { if (alive.current) setUnread(a + b); });
    load();
    const t = setInterval(load, 15000);
    return () => { alive.current = false; clearInterval(t); };
  }, []);
  return (
    <button data-testid="nav-chat-icon" onClick={() => navigate("/chat")} title={unread > 0 ? `${unread} unread message${unread > 1 ? "s" : ""}` : "Pula Chat"}
      className="relative flex items-center justify-center w-9 h-9 rounded-full text-pula-green hover:bg-pula-green/10 transition-colors">
      <MessageCircle className="w-5 h-5" />
      {unread > 0 && (
        <span key={unread} data-testid="chat-unread-badge" className="animate-badge-pop absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 rounded-full bg-pula-accent text-white text-[10px] font-bold grid place-items-center border-2 border-white">
          {unread > 99 ? "99+" : unread}
        </span>
      )}
    </button>
  );
};
